/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFreelancerNoteRequest
 */
export interface UpdateFreelancerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreelancerNoteRequest
     */
    content: string;
}

/**
 * Check if a given object implements the UpdateFreelancerNoteRequest interface.
 */
export function instanceOfUpdateFreelancerNoteRequest(value: object): value is UpdateFreelancerNoteRequest {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function UpdateFreelancerNoteRequestFromJSON(json: any): UpdateFreelancerNoteRequest {
    return UpdateFreelancerNoteRequestFromJSONTyped(json, false);
}

export function UpdateFreelancerNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFreelancerNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function UpdateFreelancerNoteRequestToJSON(value?: UpdateFreelancerNoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
    };
}

